import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-more-participant-previous-meeting-popup',
  templateUrl: './more-participant-previous-meeting-popup.component.html',
  styleUrls: ['./more-participant-previous-meeting-popup.component.css']
})
export class MoreParticipantPreviousMeetingPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
